export default "__VITE_ASSET__c54775cd__"